import Snackbar from "@material-ui/core/Snackbar"
import Alert from "@material-ui/lab/Alert"
import React, { createContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import ShelfApi from "~/utils/ShelfApi.js"

export const InfotextContext = createContext()

export const InfotextProvider = ({ children }) => {
  const [infotexts, setInfotexts] = useState([])
  const { t } = useTranslation()

  async function getCurrentInventory() {
    const env = process.env.REACT_APP_ENV_NAME
    let texts = []

    try {
      const res = await ShelfApi.get("/inventories/current")

      if (env === "staging" || env === "development") {
        texts = [`ENV: ${env}`]
      }

      if (res.data && res.data.id && !res.data.is_completing) {
        texts.push(t(res.data.valid_until ? "inventoryModePaused" : "inventoryModeActive"))
      }
      setInfotexts(texts)
    } catch (e) {
      return
    }
  }

  useEffect(() => {
    getCurrentInventory()
  }, [])

  return (
    <InfotextContext.Provider
      value={{ infotexts, setInfotexts: () => getCurrentInventory() }}
    >
      {children}
      <div>
        <Snackbar
          severity="warning"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={!!infotexts.length}
        >
          <Alert severity="warning" sx={{ width: "100%" }}>
            {infotexts.join(", ")}
          </Alert>
        </Snackbar>
      </div>
    </InfotextContext.Provider>
  )
}



// WEBPACK FOOTER //
// ./src/context/InfoTextContext.js